import styled from "styled-components";
import { media } from "../../../../styles/Qtheme";
import {MobileCalVW, TabletCalVW} from "../../../../utils/CalVW";

export const Container = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.body};
  border-bottom: 1px solid ${({ theme }) => theme.p2pBorder };
  z-index: 2;
  position: relative;
`;

export const FooterTopContainer = styled.div`
    width: 1200px;
    max-width: 1750px;
    padding: 55px 20px 30px;
    margin: 0 auto;
	display: flex;

    @media ${media.desktop} {
        padding: 28px ${TabletCalVW(20)};
    }

    @media ${media.mobile} {
        padding: 44px ${MobileCalVW(16)} 0 ${MobileCalVW(16)};
    }
`;

export const FooterMenuBox = styled.ul`
    width: 100%;
    display: flex;
    justify-content: space-between;

    @media ${media.desktop} {
        flex-direction: column;
        gap: 30px;
    }
`;

export const IconContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    @media ${media.desktop} {
        display: none;
    }
`;

export const FooterBottomContainer = styled.div`
    width: 100%;
    margin: 0 auto;
    padding: 24px 0;
    text-align: center;
    border-top: 1px solid ${({theme}) => theme.p2pBorder};

    p {
        font-size: 16px;
        font-weight: 400;
        color: ${({theme}) => theme.text};


        span {
            font-weight: 700;
        }

        @media ${media.desktop} {
            text-align: center;
        }
    }

    @media ${media.desktop} {
        padding: 20px 0;
        border-top: 1px solid #e8e8e8;
    }
`;
